<template>
    <tr class="option-row-wrapper option-row" v-if="!addNewValue">
        <!-- Order -->
        <td class="order-column">
            <edit-in-place type="short-text"
                            class="edit-in-place-cell order-column"
                            :property-value="sortOrder"
                            :master-value="safeSortOrder(rowData.sortOrder)"
                            :is-master="isMaster">
                <api-handler
                    :versionId="version"
                    :masterOptionValueId="rowData.id"
                    :versionOptionValueId="versionRowData.id"
                    :option-id="rowData.optionId"
                    propertyName="sort_order"
                    @in-progress="$emit('lock-form-toggle', true)" @success="handleValueSaveSuccess" @error="$emit('lock-form-toggle', false)">
                </api-handler>
        </edit-in-place>
        </td>

        <!-- Label -->
         <td class="label-column">
            <edit-in-place type="short-text"
                            class="edit-in-place-cell"
                            :property-value="label"
                            :master-value="rowData.label"
                            :is-master="isMaster">
                <api-handler
                    :versionId="version"
                    :masterOptionValueId="rowData.id"
                    :versionOptionValueId="versionRowData.id"
                    :option-id="rowData.optionId"
                    propertyName="label"
                    @in-progress="$emit('lock-form-toggle', true)" @success="handleValueSaveSuccess" @error="$emit('lock-form-toggle', false)">
                </api-handler>
        </edit-in-place>
         </td>

        <!-- Value -->
         <td class="value-column">
            <edit-in-place  type="short-text"
                            class="edit-in-place-cell"
                            :property-value="value"
                            :master-value="rowData.value"
                            :is-master="isMaster">
                <api-handler
                    :versionId="version"
                    :masterOptionValueId="rowData.id"
                    :versionOptionValueId="versionRowData.id"
                    :option-id="rowData.optionId"
                    propertyName="value"
                    @in-progress="$emit('lock-form-toggle', true)" @success="handleValueSaveSuccess" @error="$emit('lock-form-toggle', false)">
                </api-handler>
            </edit-in-place>
         </td>

        <!-- Delete Row -->
         <td class="delete-column">
        <div @mouseleave="showDelete=false">
            <i class="trash-can ks-icon fa la-fw fa-trash" v-if="!showDelete" @mouseover="showDelete=true"></i>
            <delete-toggle v-if="showDelete" @remove="handleDeleteRow" label="Delete"></delete-toggle>
        </div>
         </td>
    </tr>

    <div class="text-field-wrapper option-row" v-else>
        <!-- Create New Value -->
        <input class="text-field-input label-column new-label-input" placeholder="Enter New Label" type="text" v-model="newLabel">
        <input class="text-field-input value-column new-value-input" placeholder="Enter New Value" type="text" v-model="newValue">
        <button class="btn btn-primary" :disabled="createDisabled" @click="createNewValueOption(true)">SAVE</button>
    </div>
</template>

<script>

import axios from 'axios';

import EditInPlace from '../edit-in-place/edit-in-place.vue';
import OptionsValueApiHandler from '../edit-in-place/api-handlers/options-values.vue';
import DeleteToggle from '../generic/delete-toggle.vue';

var base_url = window.location.protocol + "//" + window.location.host

export default {
    name: 'option-row',
    components: {
        'delete-toggle': DeleteToggle,
        'edit-in-place': EditInPlace,
        'api-handler': OptionsValueApiHandler,
    },
    props: {
        version: String,
        rowData: Object,
        optionId: String,
        addNewValue: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            showDelete: false,
            newLabel: '',
            newValue: '',
            lockVersionInput: false,
        }
    },
    computed: {
        sortOrder() {
            if (this.isMaster) {
                return this.safeSortOrder(this.rowData.sortOrder);
            }
            return this.safeSortOrder(this.versionRowData.sortOrder)
        },
        label() {
            if (this.isMaster) {
                return this.rowData.label;
            }
            return this.versionRowData.label;
        },
        value() {
            if (this.isMaster) {
                return this.rowData.value;
            }
            return this.versionRowData.value;
        },
        isMaster() {
            return this.version === "0";
        },
        createDisabled() {
            return this.newLabel == '' || this.newValue == '';
        },
        versionRowData() {
            let vRowData = {
                id: -1,
                label: '',
                sortOrder: '',
                value: '',
                version_id: -1,
            };

            if (this.version === "0") {
                return vRowData;
            }

            if (this.rowData.versions == undefined || this.rowData.versions == null || this.rowData.versions.length == 0) {
                return vRowData;
            }

            let filteredVersions = this.rowData.versions.filter((el) => {
                return (el.version_id+'') === this.version;
            });

            if (filteredVersions.length > 0) {
                return filteredVersions[0];
            }

            return vRowData;
        }
    },
    methods: {
        safeSortOrder(value) {
            if (value == null || value == undefined || value == 'null') {
                return '';
            }
            return value + '';
        },
        handleValueSaveSuccess() {
            this.$emit('lock-form-toggle', false);
            this.$emit('value-list-change');

        },
        handleVersionValueSave() {
            this.$emit('value-list-change');
        },
        handleDeleteRow() {
            axios.delete(base_url + '/pimapi/options/values/' + this.rowData.id, {})
            .then((response) => {
                this.$emit('value-list-change');
            })
            .catch((error) => {
                console.log('value delete ERROR!');
                console.log(error)
            });
        },
        createNewValueOption(navigateToLastPageOnComplete) {
            //it is possible here that we are create a new value for a version or for master

            let masterOptionValueId = null;
            let nLabel = this.newLabel;
            let nValue = this.newValue;


            if (this.rowData.hasOwnProperty('id')) {
                //creating a new value option that is a child of a master value
                masterOptionValueId = this.rowData.id;
            }

            axios.post(base_url + '/pimapi/options/'+this.optionId+'/version/' + this.version + '/value', {
                'label': nLabel,
                'value': nValue,
                'masterOptionValueId': masterOptionValueId,
            })
            .then((response) => {
                this.$emit('lock-form-toggle', false);
                this.lockVersionInput = false;
                this.$emit('value-list-change', navigateToLastPageOnComplete);
                this.newLabel = "";
                this.newValue = "";
            })
            .catch((error) => {
                console.log('create value ERROR!');
                console.log(error)
                this.$emit('lock-form-toggle', false);
                this.lockVersionInput = false;
                this.newLabel = "";
                this.newValue = "";
            });
        }
    }
}
</script>

<style lang="scss">
.edit-in-place-cell {
    margin: 3px 6px 3px 0;
}
.trash-can {
    font-size: 1.6em;
    color: #767676;
}

input.new-value-input {
    margin-right: 4px;
}

input.new-label-input {
    margin-right: 4px;

}
.order-column {
    margin-right: 5px;
}

.label-column {
    width: 100%;
    margin-right: 5px;
}
.value-column {
    width: 100%;
    margin-right: 5px;
}

</style>